import React from "react";
import styled from "styled-components";
import {colors} from "../styles/GlobalStyles";
import {  ShowModalData } from '../services/api';


const TermsWrapper = styled.div`
    max-width: 600px;
    margin: 0 auto;
    padding: 30px 40px;
    background-color: ${colors.white}; /* White background for the form */
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const TermsWrapperOne = styled.div`
    max-width: 550px;
    height: 400px;
    overflow-y: scroll;
    margin: 0 auto;
    padding: 30px 40px;
    background-color: ${colors.white}; /* White background for the form */
    border-radius: 8px;
    //box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
`;

const FormTitle = styled.h2`
    text-align: center;
    margin-bottom: 25px;
    color: ${colors.navyBlue};
`;

const Button = styled.button`
    background-color: ${colors.navyBlue};
    color: ${colors.white};
    border: none;
    padding: 12px 25px;
    font-size: 1.1em;
    font-family: 'Oswald', sans-serif; /* Button text Oswald */
    text-transform: uppercase;
    font-weight: 700;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    display: block;
    width: 20%;
    margin: 0px auto;
    margin-top: 15px;

    &:hover:not(:disabled) {
        background-color: ${colors.forestGreen};
    }

    &:disabled {
        background-color: ${colors.warmGray};
        cursor: not-allowed;
    }
`;

const Modal: React.FC<ShowModalData> = ({show, updateShow}) => {

    const clickHandler = () => {

        updateShow(false)
        console.log('Cloase terms of use popup');
    };

    return (
        <TermsWrapper>
            <FormTitle>Terms of use</FormTitle>

            <TermsWrapperOne >

                <p>
                    As a user (hereinafter “You) of this website (vendingrebates.com (the “Website”)) You agree to these
                    Terms of Use for any and all use of Vendingrebates.com (together with its owners, agents and service
                    providers, “Vending Rebates”) and subsequent communications and actions by the Vending Rebates. By
                    agreeing to these terms or by use of this site, You agree to the following terms of use.
                </p>

                <p>
                    Your Representations.<br/>
                    You represent that You are a legitimate owner/operator of a vending company and that You purchase
                    from at least one of the distributors or manufacturers listed on the Website for which You have
                    applied for a rebate. Your application is for your business (company, partnership, limited liability
                    entity or corporation). You may not apply in the name of an individual. At the request of the
                    Vending Rebates, You will supply any requested documentation for tax purposes. You agree that You
                    are responsible for any and all misuses and misrepresentations that You might make on the Website.
                    You are responsible for any resulting conflicts, liabilities or costs incurred by the Vending
                    Rebates or Website for Your misuse, misrepresentation or mistakes You have made in using the Website
                    and will hold the Vending Rebates and the Website harmless from such actions.
                </p>

                <p>
                    Invitation Only.
                    Vending Rebates and the Website selectively offer potential rebates to Vending Operators by
                    invitation only. You represent that you have received an email from no-reply@vendingrebates.com (the
                    “Email’) inviting You to join the rebate programs on the Website and have not learned or reached
                    this website in any other fashion. You further agree that You will not forward the Email nor solicit
                    other vending operators or any other third party to access or use the Website.
                </p>

                <p>
                    Vending Operator.<br/>
                    You hereby represent and warrant that You are a vending operating and purchase products for your
                    business from legitimate vending product distributors and/or manufacturers which are part of the
                    rebate offerings on the Website.
                </p>

                <p>
                    Application.<br/>
                    By entering Your information on the Website, You agree and understand that You are applying for
                    qualification for such rebate(s). You agree and understand that You are subject to review and
                    acceptance by Vending Rebates and that You have no expectation of receiving a rebate until such time
                    as You are accepted into the related rebate program for which You have applied and have met all the
                    subsequent requirements to be paid a rebate thereunder.
                </p>

                <p>
                    Acceptance.<br/>
                    Upon review, Your application may be selected for participation in the related rebate programs. You
                    will be contacted directly by Vending Rebates representatives prior to any acceptance and if You are
                    not contacted, You have not been accepted and have no expectation of receiving a rebate.
                </p>

                <p>
                    No Guarantee.<br/>
                    You agree and understand that Your application for rebates via the Website is no guarantee that You
                    are accepted or will receive a rebate and further You agree that You must be accepted and that Your
                    sales data must be received from the related distributor or manufacturer prior to being eligible for
                    any rebates offered hereunder.
                </p>

                <p>
                    No Liability.<br/>
                    You agree that Vending Rebates, the Website, its owners, service providers, agents and
                    representatives along with any distributors or manufacturers will have no liability to You for Your
                    non-acceptance or non-qualification for any and all rebates for which You might apply and that all
                    necessary prerequisites must be met prior to receipt of any rebate.
                </p>

                <p>
                    TO THE FULLEST EXTENT PERMITTED BY LAW, VENDING REBATES WILL NOT BE LIABLE FOR ANY DAMAGES OR INJURY
                    THAT ACCOMPANY OR RESULT FROM YOUR USE OF THE WEBSITE. THESE INCLUDE (BUT ARE NOT LIMITED TO)
                    DAMAGES OR INJURY CAUSED BY ANY USE OF (OR INABILITY TO USE), USE OF (OR INABILITY TO USE); FAILURE
                    OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DEFECT, DELAY IN OPERATION OR TRANSMISSION, COMPUTER
                    VIRUS, OR LINE FAILURE. TO THE FULLEST EXTENT PERMITTED BY LAW, VENDING REBATES IS NOT RESPONSIBLE
                    OR LIABLE FOR ANY DAMAGES, INCLUDING, BUT NOT LIMITED TO, DAMAGES INTENDED TO COMPENSATE SOMEONE
                    DIRECTLY FOR A LOSS OR INJURY; DAMAGES REASONABLY EXPECTED TO RESULT FROM A LOSS OR INJURY (LEGALLY,
                    "CONSEQUENTIAL DAMAGES"); OTHER MISCELLANEOUS DAMAGES AND EXPENSES RESULTING DIRECTLY FROM A LOSS OR
                    INJURY (LEGALLY, "INCIDENTAL DAMAGES"). VENDING REBATES IS NOT LIABLE EVEN FOR ITS OWN NEGLIGENCE,
                    EVEN IF ITS AUTHORIZED REPRESENTATIVE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. TO THE
                    FULLEST EXTENT PERMITTED BY LAW, VENDING REBATES SHALL HAVE NO LIABILITY TO YOU FOR ALL LOSSES,
                    DAMAGES, INJURIES, AND CLAIMS OF EVERY KIND (WHETHER THE DAMAGES ARE CLAIMED UNDER THE TERMS OF A
                    CONTRACT, OR CLAIMED TO BE CAUSED BY NEGLIGENCE OR OTHER WRONGFUL CONDUCT, OR UNDER ANY OTHER LEGAL
                    THEORY).
                </p>

                <p>
                    Violations.<br/>
                    You agree that any violation of these terms may cause irreparable damage to Vending Rebates and You
                    agree that if in any way violates the Terms of Use Rebate Vending may not have an adequate remedy at
                    law. In the event of an actual or threatened violation by You of its responsibilities and
                    obligations under the Terms of Use, You agree that Rebate Vending shall be entitled to seek an
                    injunction or specific performance for any violations or breaches by You, Your employees or agents
                    without the necessity of such damaged party showing that monetary damages would not afford an
                    adequate remedy.
                </p>

                <p>
                    Jurisdiction.<br/>
                    This Terms of Use shall be governed by all applicable Federal laws of the United States of America
                    and the laws of the State of Delaware (without applying the state's conflict-of-law principles).
                    Further, User agrees that any and all claims, disputes or causes User may have shall only be brought
                    in the proper court or authority within the jurisdiction of Delaware.
                </p>

            </TermsWrapperOne>

            <Button type={"button"} onClick={clickHandler} >
                close
            </Button>

        </TermsWrapper>
    );
}

export default Modal;
